import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { parseISO } from 'date-fns';

import DatePresenter, {
  SHORT_FORMAT,
} from '../../../../../../../../../../presenters/DatePresenter';
import RatePresenter, {
  RATES_TYPE,
} from '../../../../../../../../../../presenters/RatePresenter';
import Label from '../../../../../../../../../../components/Label';
import Group from '../../../../../../../../../../components/Group';
import Column from '../../../../../../../../../../components/Column';
import Checkbox from '../../../../../../../../../../components/Checkbox';

const FormFields = (props) => {
  const { values, onChange, errors } = props;
  const { startDate, endDate, rate, nextRate, isTemporaryRate } = values;
  const typeOptions = Object.values(RATES_TYPE).map((type) => {
    return {
      label: RatePresenter.typeReadable({
        rateType: type,
      }),
      value: type,
    };
  });
  const handleDateChange = (dateType, newDate) => {
    if (newDate) {
      const formattedDate = DatePresenter.shortFormattedDate(newDate);
      onChange(dateType, formattedDate);
    }
  };
  const handleRateChange = ({ target }) => {
    const { id, value } = target;
    onChange(id, value);
  };
  const handleTemporaryRateCheckboxClicked = ({ target }) => {
    const { id } = target;
    onChange(id, !isTemporaryRate);
    if (isTemporaryRate) {
      onChange('nextRate', '');
    }
  };

  return (
    <Group>
      <Column>
        <div className="modal-column-element">
          <Label name="rateType" title="Rate type" errors={errors} />
          <Select
            id="rateType"
            options={typeOptions}
            placeholder="Select type"
            onChange={(rateType) => onChange('rateType', rateType.value)}
            className="modal-inline-field"
            required
          />
        </div>

        <div className="modal-column-element">
          <Label name="rate" title="New rate" errors={errors} />
          <input
            value={rate}
            id="rate"
            onChange={handleRateChange}
            className="modal-inline-field"
          />
        </div>

        <div className="modal-column-element">
          <Label name="startDate" title="Rate start date" errors={errors} />
          <DatePicker
            id="startDate"
            selected={DatePresenter.dateObject(startDate)}
            onChange={(date) => handleDateChange('startDate', date)}
            dateFormat="MM-dd-yyyy"
            minDate={parseISO(DatePresenter.today())}
            className="modal-inline-field"
          />
        </div>

        <Checkbox
          id="isTemporaryRate"
          onChange={handleTemporaryRateCheckboxClicked}
          checked={isTemporaryRate}
          labelText="Temporary rate"
          className="label-bold"
        />

        <div className="modal-column-element">
          <Label name="endDate" title="Rate end date" errors={errors} />
          <DatePicker
            id="endDate"
            selected={DatePresenter.dateObject(endDate)}
            onChange={(date) => handleDateChange('endDate', date)}
            dateFormat="MM-dd-yyyy"
            disabled={!isTemporaryRate}
            className="modal-inline-field"
            minDate={parseISO(DatePresenter.today())}
          />
        </div>

        <div className="modal-column-element">
          <Label name="nextRate" title="Next rate" errors={errors} />
          <input
            value={nextRate}
            id="nextRate"
            onChange={handleRateChange}
            disabled={!isTemporaryRate}
            className="modal-inline-field"
          />
        </div>
      </Column>
    </Group>
  );
};

export default FormFields;

FormFields.propTypes = {
  values: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

FormFields.defaultProps = {
  errors: {},
};
